import { useEffect } from 'react';

import { Outlet } from 'react-router';

import { useCurrentUser, useProfiles } from '@chartai/api-client';

import { TooltipProvider } from '@/shared/components/ui/Tooltip';
import { useProfileStore } from '@/shared/stores/useProfileStore';

import { MobileSidebar } from './MobileSidebar';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

export function DashboardLayout() {
  const { user } = useCurrentUser();
  const { data: profiles } = useProfiles(user?.uid ?? '');
  const selectedProfile = useProfileStore((s) => s.selectedProfile);
  const initializeSelection = useProfileStore((s) => s.initializeSelection);

  // Auto-select first profile if none selected
  useEffect(() => {
    if (profiles && profiles.length > 0 && !selectedProfile) {
      const mapped = (profiles as Array<Record<string, unknown> & { id: string }>).map((p) => ({
        id: p.id,
        displayName: String(p['displayName'] ?? ''),
      }));
      initializeSelection(mapped);
    }
  }, [profiles, selectedProfile, initializeSelection]);
  return (
    <TooltipProvider>
      <div className="flex h-screen flex-col">
        {/* Top bar spanning full width */}
        <TopBar />
        <div className="flex flex-1 overflow-hidden">
          <div className="hidden md:flex">
            <Sidebar />
          </div>
          <MobileSidebar />
          <div className="flex flex-1 flex-col overflow-hidden">
            <main className="flex-1 overflow-y-auto p-4 lg:p-6">
              <Outlet />
            </main>
          </div>
        </div>
      </div>
    </TooltipProvider>
  );
}
